export default __webpack_public_path__ + "static/media/greenTruck.a6d8cb5c.jpg";